import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function MessageBoxModal({
  receiverName,
  receiverId,
  cancelModal,
}) {
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const navi = useNavigate();

  //styled
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const CreateMessage = { receiverId, content };

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/message`,
        CreateMessage,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (response.status === 200) {
        cancelModal();
        navi(`/Convo/${response.data}`);
      }
    } catch (error) {
      // Handle the error here (e.g., show a message to the user)
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="send-modal-content">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <form>
            <div className="send-modal-content">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">Send Message</p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="d-flex">
                <p>Send a message to</p>
                <p className="red-text fw-bold ms-2">{receiverName}</p>
                <p className="ms-2"> the club owner.</p>
              </div>

              <textarea
                placeholder="Type your message here"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                rows="4" // Adjust rows as needed for the default height
                cols="50" // Adjust cols as needed for the width (optional)
              />
            </div>
            <div className="send-modal-footer">
              <button
                className="saveChanges-button mx-3"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                Send
              </button>
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={cancelModal}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
